import MiddleText from '@/components/MiddleText/MiddleText'
import styles from './ASteps.module.less'
import cls from 'classnames'

const COMPONENT_NAME = 'A-Steps'

interface Props {
  current: number
  items: Array<{ title: string }>
  testId?: string
}
function ASteps(props: Props) {
  return (
    <div className={styles[COMPONENT_NAME]} data-testid={props.testId}>
      {props.items.map((item, index) => {
        return (
          <div
            key={index}
            className={cls(styles['A-Steps-item'], {
              [styles['last-item']]: index === props.items.length - 1,
            })}
          >
            <div
              className={cls(styles['A-Steps-item-cnt'], {
                [styles['active']]: props.current >= index,
              })}
            >
              {index + 1}
            </div>
            <div
              className={cls(styles['A-Steps-item-title'], {
                [styles['active']]: props.current >= index,
              })}
            >
              <MiddleText text={item.title} />
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default ASteps
